import { translations } from "./translations";
import { WHATSAPP_PHONE } from "./contact-config.js";

function getCurrentLanguage() {
  return localStorage.getItem("language") || "ro";
}

function getWhatsAppStrings(lang) {
  return (
    translations[lang]?.common?.whatsapp ||
    translations.en.common.whatsapp
  );
}

function buildWhatsAppUrl(lang) {
  const { prefill } = getWhatsAppStrings(lang);
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(prefill)}`;
}

function updateWhatsAppLinks() {
  const lang = getCurrentLanguage();
  const { label } = getWhatsAppStrings(lang);
  const url = buildWhatsAppUrl(lang);

  document.querySelectorAll("[data-whatsapp-link]").forEach((link) => {
    link.href = url;
    link.setAttribute("aria-label", label);
    link.setAttribute("title", label);
  });
}

export function initWhatsAppFloat() {
  updateWhatsAppLinks();
  document.addEventListener("languageChanged", updateWhatsAppLinks);
}
